module.exports = __webpack_public_path__ + "img/39_55.ce0c07e8.png";